import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { PDFDocument } from "pdf-lib";
import { AgriProductsAPMC, AmendmentStaffMarketCommittee, AppointmentSecretaryAPMC, BuyingLandAPMC,ContractualAppointmentSecretaryAPMC,PayComission,PermAppointmentSecretaryAPMC,PromotionSecretaryMarketCommittee,ProposalDonation,ProposalLoan,SellingLandAPMC, StudyTour, YardAPMC } from '../Json/AllData';
// @ts-ignore
import html2pdf from "html2pdf.js"
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CommonSelect from "./commonSelect";
import { getAllApmcDocument } from "../../../auth/services/privateapicalling";

import { Certificate10, Certificate11, Certificate12, Certificate13, Certificate7, Certificate8, Certificate9, Certificates1, Certificates2, Certificates3, Certificates4, Certificates5, Certificates6 } from "./CertificatesForm";
interface DownloadProps {
  type:any;
  existData:any;
  applicationId?: any;
}

const DownloadFormApplication: React.FC<DownloadProps> = ({
    type,
    existData,
    applicationId
}) => {
  const language = useSelector((state: any) => state.auth.language);
    const pdfRef = useRef<HTMLDivElement>(null);
    const [check,setCheck]= useState(false);
    const [issued,setIssued]= useState(true);
    const token = useSelector((state:any)=>state.auth.token);
    const[pdfData, setPdfData] = React.useState<any>(null);
  let heading ="";
   const[certificateData,setCertificateData]= useState({
     positionName:existData?.positionName ||"",
     FilledFormName:existData?.FilledFormName ||"",
   })
const getDataField = () => {

  const typeNum = Number(type);
  
  switch (typeNum) {
    case 39:
       heading = "Buying Land";
      return BuyingLandAPMC;
    case 40:
      heading = "Selling Land";
      return SellingLandAPMC;
    case 41:
      heading = "To control Agriculture products under the APMC - Application under Form-8";
      return AgriProductsAPMC;
    case 42:
    heading  ="Declaration of the main yard/sub-yard of APMC";
    return YardAPMC;
    case 43:
      heading = " the new/permanent or temporary appointment of the Secretary in the Market Committee";
      return AppointmentSecretaryAPMC;
    case 44:
      heading = "Permanent appointment of Secretary in the Market Committee";
      return PermAppointmentSecretaryAPMC;
    case 45:
      heading = "Regarding amendment in the staff schedule of the Market Committee";
      return AmendmentStaffMarketCommittee;
      case 46:
        heading = "Regarding promotion from Assistant Secretary / Inspector to Secretary in the Market Committee";
        return PromotionSecretaryMarketCommittee;
    case 47:
      heading = "Regarding contractual appointment of Secretary / employee after retirement";
      return ContractualAppointmentSecretaryAPMC;
    case 48:
      heading ="Regarding approval of 7th Pay Commission for Secretary / employee";
      return PayComission;
    case 49:
      heading = " Proposals regarding donation";
      return ProposalDonation;
    case 50:
      heading = "Proposals regarding loan";
      return ProposalLoan;
    case 51:
      heading = "Approval for Study Tours";
      return StudyTour;
    default:
      return BuyingLandAPMC;
  }
};
const getCertificates = () => {
   
    const typeNum = Number(type);
   
  switch (typeNum) {
    case 39:
      return (
        <div>
          {existData && applicationId && <Certificates1 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    case 40:
      return (
        <div>
          {existData && applicationId && <Certificates2 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    case 41:
      return (
        <div>
          {existData && applicationId && <Certificates3 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    case 42:
      return (
        <div>
          {existData && applicationId && <Certificates4 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    case 43:
      return (
        <div>
          {existData && applicationId && <Certificates5 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    case 44:
      return (
        <div>
          {existData && applicationId && <Certificates6 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    case 45:
      return (
        <div>
          {existData && applicationId && <Certificate7 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    case 46:
      return (
        <div>
          {existData && applicationId && <Certificate8 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    case 47:
      return (
        <div>
          {existData && applicationId && <Certificate9 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    case 48:
      return (
        <div>
          {existData && applicationId && <Certificate10 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    case 49:
      return (
        <div>
          {existData  && <Certificate11 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    case 50:
      return (
        <div>
          {existData && applicationId && <Certificate12 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    case 51:
      return (
        <div>
          {existData && applicationId && <Certificate13 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData}/>}
        </div>
      );
    
  }
  };
  const selectFn = (response:any ) => {
    const options = [
      { value: "option1", label: "Option 1" },
      { value: "option2", label: "Option 2" }
    ];
 
    // const handleChange = (selectedOption: Option | null,fieldName:string) => {
    //   setFormData(prev=>{
    //   const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
    //   const index = arr.findIndex(item => item.fieldName === fieldName);
    //   if (index !== -1) {
    //     arr[index] = { ...arr[index], value: selectedOption?.value || "" };
    //   } else {
    //     arr.push({  value: selectedOption?.value ||"", fieldName: fieldName });
    //   }
    //   return { ...prev, [fieldName]: arr };
     
    // })
    // };
 
    const selectedValue = ""
 
    return (
      <CommonSelect
        options={options}
        // value={selectedValue}
        name={response?.responseVal}
        // onChange={(e)=>handleChange(e, response?.fieldName)}
        placeholder={`Select ${response?.responseVal}`}
        className="w-100"
      />
    );
  };
 
  const inputFn = (response:any) => {
    return (
      <input
        type="text"
        className="p-2 form-control"
        placeholder={`Enter ${response?.responseVal}`}
        name={response?.responseVal}
        value={existData?.annexureOne?.[response?.fieldName]?.data?.find(item=>item.fieldName===response?.responseVal)?.value || ""}
        // onChange={(e)=>handleInputChange(e, response?.fieldName)}
        disabled={true}
      />
    );
  };
 
    const numberFn = (response:any) => {
    return (
      <input
        type="number"
        className="p-2 form-control"
        placeholder={`Enter ${response?.responseVal}`}
        name={response?.responseVal}
        value={existData?.annexureOne?.[response?.fieldName]?.data?.find(item=>item.fieldName===response?.responseVal)?.value || ""}
        // onChange={(e)=>handleInputChange(e, response?.fieldName)}
        disabled={true}
      />
    );
  };
 
  const radioFn = (response:any) => {
   
   return (
    <div className="d-flex w-100 gap-2">
      <input
        type="radio"
        name={response?.responseVal}
        value="yes"
        disabled={true}
        checked={existData?.annexureOne?.[response?.fieldName]?.data?.find(item=>item.fieldName===response?.responseVal)?.value === "yes"}
                // onChange={(e)=>handleInputChange(e, response?.fieldName)}
 
      />{" "}Yes
      <input
        type="radio"
        name={response?.responseVal}
        value="no"
        disabled={true}
        checked={existData?.annexureOne?.[response?.fieldName]?.data?.find(item=>item.fieldName===response?.responseVal)?.value === "no"}
            //   onChange={(e)=>handleInputChange(e, response?.fieldName)}
 
      />{" "}No
    </div>)
  };
 
  const percentageFn = (response:any) => (
    <input
      className="form-control"
      type="text"
      inputMode="decimal"
      name={response?.responseVal}
      placeholder="0 - 100"
      value={existData?.annexureOne?.[response?.fieldName]?.find(item=>item.fieldName===response?.responseVal)?.value || ""}
        // onChange={(e)=>handleInputChange(e, response?.fieldName)}
        disabled={true}
 
    />
  );
   const dateFn = (response:any) => {
    return (
        <div className="d-flex flex-column">
      <input
        type="date"
        className={`p-2 form-control  ? 'border border-danger' : ''}`}
        name={response?.responseVal}
        value={existData?.annexureOne?.[response?.fieldName]?.find(item=>item.fieldName===response?.responseVal)?.value || ""}
        onChange={(e) => {
        //   handleInputChange(e, response?.fieldName);
        
        }}
        disabled={true}
      />
    
      <small className="text-muted mt-1 ms-1">{response.responseName}</small>

      </div>
    );
  };

  
const fileButtonFn = (fieldName , docName) => {
  const docData = existData?.annexureOne?.[fieldName];
  const docId = docData?.data.find(data=>data.documentName == docName)?.docId;

  return (
     <small className="text-muted mt-1 ms-1">
      {docData?.data.find((item: any) => item.documentName === docName)?.fileName || docData?.data.find((item: any) => item.documentName === docName)?.documentName }
    </small>
  );
};
 
const dataField = getDataField();

  

  const fetchallDocs = async (): Promise<ArrayBuffer | null> => {
    try {
      const response = await getAllApmcDocument(applicationId, token, "apmc");
      
  
      // If API already returns ArrayBuffer (Axios with responseType:"arraybuffer")
      // then response is already an ArrayBuffer
      // otherwise, if response is Blob, convert it
      let buffer: ArrayBuffer;
  
      if (response instanceof Blob) {
        buffer = await response.arrayBuffer();
      } else {
        buffer = response as ArrayBuffer;
      }
  
      // Debug: preview PDF
    //   const blob = new Blob([buffer], { type: "application/pdf" });
    //   const url = URL.createObjectURL(blob);
    //   window.open(url);
       setPdfData(buffer); // Store the ArrayBuffer in state
      return buffer; // ✅ return ArrayBuffer
    } catch (error) {
   
      return null; // ✅ safer than {}
    }
  };
  
  const getJsxPdfBuffer = async (): Promise<ArrayBuffer | null> => {
    if (!pdfRef.current) return null;

    const clonedContent = pdfRef.current.cloneNode(true) as HTMLElement;
    clonedContent.style.display = "block";

    // html2pdf returns a promise chain, need .output("blob")
    const pdfBlob: Blob = await html2pdf()
      .from(clonedContent)
      .set({
        margin: [10, 10, 10, 10], // top, left, bottom, right in mm
        filename: "temp.pdf", // not downloaded
        html2canvas: { 
          scale: 1.5, // Reduced scale for better rendering
          allowTaint: true,
          useCORS: true,
          backgroundColor: "#ffffff"
        },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] }, // Prevent content from breaking mid-row
      })
      .output("blob");

    return await pdfBlob.arrayBuffer();
  };

  const mergePdfs = async (
    appPdfBuffer: ArrayBuffer,
    docsPdfBuffer: ArrayBuffer,
    applicationId: string
  ) => {
    const mergedPdf = await PDFDocument.create();

    // Add JSX pages
    const appDoc = await PDFDocument.load(appPdfBuffer);
    const appPages = await mergedPdf.copyPages(appDoc, appDoc.getPageIndices());
    appPages.forEach((p) => mergedPdf.addPage(p));

    // Add backend docs pages
    const docsDoc = await PDFDocument.load(docsPdfBuffer);
    const docsPages = await mergedPdf.copyPages(docsDoc, docsDoc.getPageIndices());
    docsPages.forEach((p) => mergedPdf.addPage(p));

    // Save final
    const mergedBytes = await mergedPdf.save();

    // Trigger download
    const blob = new Blob([mergedBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Form_Application_${applicationId}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };
  const downloadMergedPdf = async () => {
    const appPdf = await getJsxPdfBuffer();        // from div
    const docsPdf =await fetchallDocs(); // from backend
    //  const docsPdf = await pdfData
    if (appPdf && docsPdf) {
      await mergePdfs(appPdf, docsPdf, applicationId);
    }
  };
    // const downloadPDF = async () => {
    //     if (pdfRef.current) {
    //       const clonedContent = pdfRef.current.cloneNode(true) as HTMLElement;
    //       clonedContent.style.display = "block"; // Ensure content is visible in PDF
    //       const pdfBlob = await html2pdf().from(clonedContent).set({
    //         margin: 10, // Add margin to avoid content clipping
    //         filename: `Form_Application${applicationId}.pdf`,
    //         html2canvas: { scale: 4},  // Adjust the scale to fit content
    //         jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    //       })
    //       .outputPdf("blob");
    //     // .save(`Form_Application${applicationId}.pdf`);
    //     return await pdfBlob.arrayBuffer();
    //     }
    //   };
//  useEffect(() => {
//     fetchallDocs();
//     }
//     , [applicationId, token]);

  return (<>
    <div ref={pdfRef} style={{ display:"none",width:"100%" ,fontFamily: "Arial, sans-serif", padding: "10px" }}>
  
 
        <h2 className='my-3 mb-4'>Proposal for permission for {heading} </h2>
              <div className="w-100">
            <div className="row mb-4">
  <div className="col text-start mt-4">
    Application ID: {applicationId}
  </div>


</div>
            <div className='d-flex flex-column text-nightblue align-items-center justify-content-center  '>
              <div id='table' className='w-100 border overflow-hidden bg-white border-secondary rounded mb-3' style={{ pageBreakInside: 'avoid' }}>
   
                <div id='head' className='d-flex w-100  rounded-top border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                    <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                    <h4 className='col-5 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
               
                      <h4 className='col-6 p-2 justify-content-center d-flex align-items-center border-end border-secondary'>જવાબ(Response)</h4>
                  
                   
                   
                </div>
                {dataField && dataField.length > 0 &&
                dataField.map((item,index)=>{
                  return(
                    <React.Fragment key={index}>
                      <div className={`d-flex border-top border-secondary`} style={{ pageBreakInside: 'avoid' }}>
                          <h4 className='col-1 d-flex align-items-center justify-content-center'>{item.fieldNo}</h4>
                        <div className='col-5 '>
                            <p className='d-flex align-items-center h-100 p-3 border-start border-end border-secondary'>
                            {item.fieldVal}*
                            </p>
                        </div>

                    
                          <div className='col-6 d-flex border-end border-secondary justify-content-center align-items-center'>
                            <div className='w-75 d-flex flex-column p-2 gap-2 '>
                              {item.response.map((newObj, indx) => {
                                const docName = newObj.responseVal;
                                const fieldName = item.fieldName;

                                const inputKey = `${index}_${indx}`;
                                const divVal =
                                  newObj.responseType === "select"
                                    ? selectFn(newObj)
                                    : newObj.responseType === "input"
                                    ? inputFn(newObj)
                                    : newObj.responseType === "number"
                      ? numberFn(newObj)
                      : newObj.responseType === "radio"
                      ? radioFn(newObj)
                      : newObj.responseType === "percentage"
                      ? percentageFn(newObj)
                        : newObj.responseType === "date"
                                      ? dateFn(newObj)
                      : newObj.responseType === "file"
                      ? fileButtonFn(fieldName , docName)
                      : <></>;
                  return (
                    <div className=" d-flex align-items-center justify-content-center" key={inputKey}>
                      {divVal}
                    </div>
                  );
                })}
              </div>
      
          
          </div>
     
        </div>

            {/* Edit Form */}
        
          </React.Fragment>
        )
      })}
     
      </div>
    </div>
    <div style={{ pageBreakBefore: 'always',paddingTop: '40px' }}>
      {getCertificates()}
    </div>
      </div>

    </div>

     <div style={{ marginTop: "20px", textAlign: "center" }}>
     <button
       onClick={downloadMergedPdf}
       style={{
         padding: "10px 20px",
         fontSize: "16px",
         cursor: "pointer",
         backgroundColor: "#007bff",
         color: "white",
         border: "none",
         borderRadius: "5px",
       }}
     >
       {language.down_pdf}
     </button>
   </div>
   </>
  );
};

export default DownloadFormApplication;
